import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { ImageboxFullwidthComponent } from './imagebox-fullwidth.component';  

@NgModule({
  declarations: [ImageboxFullwidthComponent],
  exports: [ImageboxFullwidthComponent],
  imports: [
    CommonModule 
  ]
})
export class ImageboxFullwidthModule {}
